/**
 * GIFT4TEE — bao cho khach khi con field bat buoc chua nhap, luc bam ADD TO CART.
 *
 * VI SAO PHAI TU VIET
 * Theme khong dung `required` cua HTML cho cac field line item property. The
 * <hdt-block-required> (blocks/_product-item-property.liquid:56-103) khi khoi tao
 * se GO attribute `required`, gan class is-required, roi dat co
 * `form.checkBreak = true`. Handler submit cua ProductForm (assets/global.min.js)
 * thoat ngay dong dau khi thay co nay:
 *     if (t.preventDefault(), this.form.checkBreak) return;
 * => khong goi /cart/add.js, khong ban cart:update, popup cung khong hien ra.
 *
 * Con khoi bao loi cua theme (rung + focus vao field trong) thi khong bao gio chay,
 * vi guard cua no la `t.target.id !== this.attrForm`. `t.target` la the <form>, ma
 * form san pham co <input type="hidden" name="id"> (blocks/_product-buy-button.liquid:69);
 * HTMLFormElement co [LegacyOverrideBuiltIns] nen `form.id` tra ve chinh cai input
 * do thay vi chuoi id => so sanh element voi string luon khac nhau => guard luon
 * dung => ca khoi bao loi bi nhay qua. (Form gio hang khong co input name="id" nen
 * o do phan bao loi cua theme van chay binh thuong — chi form san pham bi.)
 * Vi vay o duoi khong doc `form.id` o dau ca; lay form so huu qua `control.form`.
 *
 * CACH LAM
 * Nghe `submit` o PHA CAPTURE tren document: chay truoc handler cua ProductForm
 * (gan tren chinh the <form>, pha bubble) nen con kip chan submit va con kip dat
 * lai co checkBreak theo tinh trang thuc te cua cac field.
 *
 * Doi chu hien thi thi sua MSG_TEXT / MSG_CHOICE ngay duoi. Theme khong co san cau
 * dich nao khop nen de tieng Anh cho dong bo voi popup.
 */
(function () {
  'use strict';

  var MSG_TEXT = 'Please fill in this field';
  var MSG_CHOICE = 'Please select an option';

  /* ------------------------------------------------------------- doc trang thai */

  /**
   * Form so huu block. Cac field property nam ngoai the <form> (chung o cot thong
   * tin, form chi boc hang nut mua) va gan vao form qua attribute form="..." nen
   * phai hoi chinh control chu khong duyet cay DOM.
   */
  function formOf(block) {
    var control = block.querySelector('[form]');
    return control ? control.form : null;
  }

  function focusTargetOf(block) {
    return (
      block.querySelector('input:not([type="hidden"]), select, textarea') ||
      block.querySelector('[form]')
    );
  }

  /**
   * Block co dang bat buoc hay khong. Attribute `required` da bi theme go nen doc
   * theo class is-required: theme gan class nay luc khoi tao va chi bo khi field
   * da co gia tri (block_required_on_change_fn). Van doc them [required] cho
   * truong hop script nay chay truoc khi custom element cua theme kip khoi tao.
   */
  function isRequired(block) {
    return block.classList.contains('is-required') || !!block.querySelector('[required]');
  }

  function isFilled(block) {
    if (block.getAttribute('detect') === 'checked') {
      // <select> luon co gia tri nen co chon la xong. Theme chi tim input:checked
      // nen no danh dau block kieu select la chua chon vinh vien — tinh lai o day.
      var select = block.querySelector('select');
      if (select) return select.value.length > 0;
      if (block.querySelector('input:checked')) return true;
      // kieu options danh dau nhieu o: gia tri that gom trong mot input an
      var hidden = block.querySelector('input[type="hidden"][name^="properties["]');
      return !!hidden && hidden.value.length > 0;
    }
    // input[type=date] phai co trong danh sach, khong thi block kieu ngay luon bi
    // coi la chua nhap va khong bao gio qua duoc validate khi gan tag REQ_
    var field = block.querySelector('input[type="text"], input[type="date"], textarea');
    // theme chi xet length; them trim de mot dau cach khong tinh la da nhap
    return !!field && field.value.trim().length > 0;
  }

  function blocksOf(form) {
    var found = [];
    Array.prototype.forEach.call(document.querySelectorAll('hdt-block-required'), function (block) {
      if (formOf(block) === form) found.push(block);
    });
    return found;
  }

  /* -------------------------------------------------------------- bao loi len UI */

  function message(block) {
    var msg = block.querySelector('.g4t-required-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'g4t-required-msg';
      // role=alert de trinh doc man hinh doc len ngay khi dong nay hien ra
      msg.setAttribute('role', 'alert');
      msg.textContent = block.getAttribute('detect') === 'checked' ? MSG_CHOICE : MSG_TEXT;
      block.appendChild(msg);
    }
    return msg;
  }

  function shake(block) {
    block.classList.remove('g4t-shake');
    // doc mot thuoc tinh layout de trinh duyet chot lai trang thai; khong co dong
    // nay thi bo class roi gan lai trong cung mot frame se khong chay lai animation
    void block.offsetWidth;
    block.classList.add('g4t-shake');
  }

  function markInvalid(block) {
    block.classList.add('g4t-invalid');
    var control = focusTargetOf(block);
    if (control) control.setAttribute('aria-invalid', 'true');
    message(block).hidden = false;
    shake(block);
  }

  function clearInvalid(block) {
    if (!block.classList.contains('g4t-invalid')) return;
    block.classList.remove('g4t-invalid');
    var control = focusTargetOf(block);
    if (control) control.removeAttribute('aria-invalid');
    var msg = block.querySelector('.g4t-required-msg');
    if (msg) msg.hidden = true;
  }

  /* ----------------------------------------------------------- thanh nut sticky */

  /**
   * Thanh nut dinh o day trang (sections/main-product.liquid:168) la MOT FORM RIENG
   * (`form-product-sticky<id>`), cac field property khong thuoc no — neu khong xu ly
   * thi bam ATC o thanh do se bo qua het field bat buoc. The boc ngoai co san
   * attribute form="<id form chinh>" nen lay form chinh theo do.
   */
  function ownerFormOf(form) {
    var sticky = form.closest('hdt-sticky-btn-atc');
    if (!sticky) return form;
    var id = sticky.getAttribute('form');
    return (id && document.forms[id]) || form;
  }

  /**
   * Copy gia tri properties[...] cua form chinh sang form sticky duoi dang input an,
   * de dong hang trong gio van co Nickname/Names khi khach mua tu thanh sticky.
   * Chay o pha capture nen kip truoc luc ProductForm dung `new FormData(form)`.
   */
  function mirrorProperties(source, target) {
    Array.prototype.forEach.call(target.querySelectorAll('[data-g4t-mirror]'), function (old) {
      old.remove();
    });
    Array.prototype.forEach.call(document.querySelectorAll('[name^="properties["]'), function (field) {
      if (field.form !== source) return;
      // o chua danh dau thi khong gui gi ca, giong hanh vi form thuong
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      if (!field.value) return;
      var copy = document.createElement('input');
      copy.type = 'hidden';
      copy.name = field.name;
      copy.value = field.value;
      copy.setAttribute('data-g4t-mirror', '');
      target.appendChild(copy);
    });
  }

  /* ------------------------------------------------------------------ kiem tra */

  function validate(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    // chi cac form them vao gio: trang san pham, quick view, quick add, bundle
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;

    var owner = ownerFormOf(form);
    if (owner !== form) mirrorProperties(owner, form);

    var blocks = blocksOf(owner);
    if (!blocks.length) return;

    var empty = [];
    blocks.forEach(function (block) {
      if (!isRequired(block) || isFilled(block)) {
        clearInvalid(block);
      } else {
        empty.push(block);
      }
    });

    // Dat lai co cua theme theo tinh trang thuc te. Theme chi cap nhat co nay khi
    // co su kien input/change nen no lech duoc (khach dung autofill, hoac block
    // kieu select ma theme khong bao gio danh dau la da chon).
    owner.checkBreak = empty.length > 0;
    if (owner !== form) form.checkBreak = owner.checkBreak;

    if (!empty.length) return;

    event.preventDefault();
    empty.forEach(markInvalid);

    var target = focusTargetOf(empty[0]);
    if (!target) return;
    // scroll truoc roi focus: focus() cung tu keo man hinh nhung nhay, khong muot
    if (target.scrollIntoView) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    try {
      target.focus({ preventScroll: true });
    } catch (error) {
      target.focus();
    }
  }

  /* ------------------------------------------------------------------- go bao loi */

  function onEdit(event) {
    var node = event.target;
    var block = node && node.closest ? node.closest('hdt-block-required') : null;
    // chi go khi da nhap that su; con trong thi giu vien do va dong chu lai
    if (block && isFilled(block)) clearInvalid(block);
  }

  // pha capture: chay truoc handler cua ProductForm gan tren chinh the <form>
  document.addEventListener('submit', validate, true);
  document.addEventListener('input', onEdit);
  document.addEventListener('change', onEdit);
  // don class sau khi rung xong de lan bam sau con rung tiep
  document.addEventListener('animationend', function (event) {
    var node = event.target;
    if (node.classList && node.classList.contains('g4t-shake')) node.classList.remove('g4t-shake');
  });
})();
